import { createStateSelectorHook } from 'src/lib/sweetState';

import { PageStore } from './store';

export const useViewState = createStateSelectorHook(PageStore, [
  'approving',
  'appDisplayName',
  'appNameLoading',
  'appNameError',
  'copilotAccountName',
  'copilotWorkspaceName',
  'infoLoading',
]);
